// extracted by mini-css-extract-plugin
export default {"cls1":"SeasonalDiscountUnibrow-cls1___b2771f81c297f727fe9","cls2":"SeasonalDiscountUnibrow-cls2__b150afdf5add9b8fc429 SeasonalDiscountUnibrow-cls1___b2771f81c297f727fe9"};